<div class="new-update-screen">
  <!-- Environment Details Section -->
  <div class="section">
    <div class="section-header">Environment Details:</div>
    <div class="search-controls">
      <div class="control-group">
        <div class="control-label">Environment:</div>
        <select class="form-control input-sm"
          [(ngModel)]="selectedEnv"
          [compareWith]="compareEnv">
          @for (env of environmentList; track env) {
            <option [ngValue]="env">{{env.label}}</option>
          }
        </select>
      </div>
      <div class="control-group">
        <div class="control-label">Table Name:</div>
        <input type="text"
          class="form-control"
          name="tableName"
          [(ngModel)]="tableName"
          required>
        </div>
        <div class="control-group control-button">
          <button class="btn btn-info btn-sm"
            [disabled]="isFetchLoading"
            (click)="fetchTableDetails()">
            Fetch
            @if (isFetchLoading) {
              <i class="fa fa-spinner fa-pulse"></i>
            }
          </button>
        </div>
      </div>
    </div>

    <!-- No Records Message -->
    @if (showNoDataMsg) {
      <div class="no-data-message">
        <span>No records to display.</span>
      </div>
    }

    <!-- Table Details Section -->
    @if (tableList.length > 0) {
      <div class="section">
        <div class="section-header">Table Details:</div>
        <div class="table-container">
          <table class="table table-bordered table-striped table-sticky-col">
            <thead>
              <tr>
                <th class="col-sticky">COLUMN_NAME</th>
                <th>DATA_DEFAULT</th>
                <th>DATA_TYPE</th>
                <th>DEFAULT_ON_NULL</th>
                <th>IDENTITY_COLUMN</th>
                <th>NULLABLE</th>
                <th>USER_GENERATED</th>
                <th>VIRTUAL_COLUMN</th>
                <th>CONDITION_COLUMN</th>
                <th>DATA_COLUMN</th>
                <th class="col-value">VALUE</th>
              </tr>
            </thead>
            <tbody>
              @for (row of tableList; track trackByIndex(i); let i = $index) {
                <tr>
                  <td class="col-sticky">{{ row.COLUMN_NAME }}</td>
                  <td>{{ row.DATA_DEFAULT }}</td>
                  <td>{{ row.DATA_TYPE }}</td>
                  <td>{{ row.DEFAULT_ON_NULL }}</td>
                  <td>{{ row.IDENTITY_COLUMN }}</td>
                  <td>{{ row.NULLABLE }}</td>
                  <td>{{ row.USER_GENERATED }}</td>
                  <td>{{ row.VIRTUAL_COLUMN }}</td>
                  <td>
                    <input type="checkbox" [(ngModel)]="row.CONDITION_COLUMN"/>
                  </td>
                  <td>
                    <input type="checkbox" [(ngModel)]="row.DATA_COLUMN"/>
                  </td>
                  <td class="col-value">
                    <input type="text"
                      class="form-control"
                      name="value_{{i}}"
                      [(ngModel)]="row.VALUE">
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="action-buttons">
            <button class="btn btn-success btn-sm"
              [disabled]="isCreateLoading"
              (click)="performAction('Create')">
              Create
              @if (isCreateLoading) {
                <i class="fa fa-spinner fa-pulse"></i>
              }
            </button>
            <button class="btn btn-info btn-sm"
              [disabled]="isGetImpactedLoading"
              (click)="fetchImpactedData()">
              Get Impacted Data
              @if (isGetImpactedLoading) {
                <i class="fa fa-spinner fa-pulse"></i>
              }
            </button>
          </div>
        </div>
      }

      <!-- No Impacted Records Message -->
      @if (showImpactedNoDataMsg) {
        <div class="no-data-message">
          <span>No Impacted records to display.</span>
        </div>
      }

      <!-- Impacted Table Details Section -->
      @if (impactedTableList.length > 0) {
        <div class="section">
          <div class="section-header">Impacted Table Details:</div>
          <div class="table-container">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  @for (key of impactedTableKeys; track key) {
                    <th>{{key}}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of impactedTableList; track trackByIndex(i); let i = $index) {
                  <tr>
                    @for (key of impactedTableKeys; track key) {
                      <td>{{getImpactedValue(row, key)}}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="action-buttons">
            <div class="action-buttons-left">
              <button class="btn btn-warning btn-sm"
                [disabled]="isUpdateLoading"
                (click)="performAction('Update')">
                Update
                @if (isUpdateLoading) {
                  <i class="fa fa-spinner fa-pulse"></i>
                }
              </button>
              <button class="btn btn-danger btn-sm"
                [disabled]="isDeleteLoading"
                (click)="performAction('Delete')">
                Delete
                @if (isDeleteLoading) {
                  <i class="fa fa-spinner fa-pulse"></i>
                }
              </button>
            </div>
            <button class="btn btn-info btn-sm"
              (click)="exportImpactedDataToExcel()">
              Export to Excel
            </button>
          </div>
        </div>
      }
    </div>
